module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-16 at 09.14.41.61d3c5d2.png";